var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdv4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 60,
    viewBox: "0 0 97 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_100743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100586 28.1669C0.100586 26.7112 1.06708 25.2554 3.00008 24.1447L41.5001 2.02223C45.366 -0.199162 51.6341 -0.199202 55.5001 2.02223L94 24.1447C95.933 25.2554 96.899 26.7111 96.899 28.1669V32.1892C96.899 30.7334 95.933 29.2776 94 28.1669L55.5001 6.04449C51.6341 3.82306 45.366 3.8231 41.5001 6.04449L3.00008 28.1669C1.06708 29.2776 0.100586 30.7334 0.100586 32.1892V28.1669Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_696_100743)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.899 28.1669C96.899 29.6227 95.933 31.0785 94 32.1892L55.5001 54.3116C51.6341 56.533 45.366 56.533 41.5001 54.3116L3.00008 32.1892C1.06708 31.0784 0.100586 29.6227 0.100586 28.1669V32.1892C0.100586 33.6449 1.06708 35.1007 3.00008 36.2114L41.5001 58.3339C45.366 60.5553 51.6341 60.5553 55.5001 58.3339L94 36.2114C95.933 35.1007 96.899 33.6449 96.899 32.1892V28.1669Z",
    fill: "url(#paint0_linear_696_100743)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6671 2.12769L3.18368 24.2406C-0.590133 26.409 -0.590133 29.9248 3.18368 32.0933L41.6671 54.2062C45.4409 56.3746 51.5595 56.3746 55.3333 54.2062L93.8167 32.0933C97.5905 29.9248 97.5905 26.409 93.8167 24.2406L55.3333 2.12769C51.5595 -0.0407805 45.4409 -0.0407793 41.6671 2.12769Z",
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.404145
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4585 39.1881C38.267 39.2981 38.0428 39.3544 37.7859 39.3568C37.5377 39.3543 37.3251 39.3022 37.1483 39.2005C36.963 39.0941 36.8723 38.9719 36.8763 38.8342L36.3904 34.2933C36.3567 33.9739 36.279 33.6991 36.1572 33.4691C36.0441 33.234 35.8697 33.0487 35.6338 32.9132C35.2633 32.7003 34.8779 32.5539 34.4779 32.4741C34.0778 32.3943 33.6843 32.3832 33.2974 32.441C32.902 32.494 32.5346 32.618 32.1951 32.813C31.8643 33.0031 31.6482 33.2241 31.5468 33.4759C31.4457 33.7179 31.4558 33.9638 31.577 34.2135C31.6985 34.4534 31.9235 34.6677 32.252 34.8565C32.4204 34.9533 32.5025 35.0755 32.4983 35.2231C32.5027 35.3657 32.4092 35.492 32.2177 35.6021C32.0349 35.7071 31.8151 35.7609 31.5581 35.7633C31.3012 35.7657 31.0886 35.7186 30.9201 35.6218C30.3474 35.2927 29.9728 34.9224 29.7963 34.5108C29.6113 34.0944 29.619 33.6787 29.8193 33.2636C30.0283 32.8434 30.4244 32.4658 31.0076 32.1307C31.5995 31.7906 32.2353 31.5656 32.9147 31.4559C33.5942 31.3461 34.2747 31.3519 34.9561 31.4734C35.6462 31.5898 36.2986 31.8247 36.9135 32.178C37.183 32.3328 37.3958 32.5251 37.5518 32.7548C37.7166 32.9796 37.8339 33.217 37.9038 33.4673C37.9823 33.7125 38.0313 33.9457 38.0506 34.1669L38.3451 37.7724L42.0011 35.6716C42.1926 35.5616 42.4211 35.5077 42.6864 35.5101C42.9433 35.5077 43.156 35.5549 43.3244 35.6517C43.5013 35.7533 43.5876 35.8779 43.5833 36.0255C43.5791 36.1732 43.4812 36.302 43.2897 36.412L38.4585 39.1881Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7758 39.6577C37.3909 39.6537 37.0496 39.5696 36.7779 39.4135C36.5081 39.2584 36.3524 39.0645 36.3527 38.8427L35.8679 34.3122C35.836 34.0091 35.7631 33.7586 35.6564 33.5571L35.6525 33.5497C35.5571 33.3513 35.4203 33.2163 35.2635 33.1262C34.9357 32.9378 34.6155 32.8202 34.3056 32.7584C33.997 32.6968 33.7091 32.6903 33.4286 32.7322L33.4157 32.7341C33.1319 32.7722 32.8483 32.863 32.5653 33.0256C32.3011 33.1775 32.1356 33.3487 32.0572 33.5433L32.0562 33.5458C31.977 33.7353 31.9832 33.9286 32.0808 34.1306C32.1763 34.318 32.3528 34.4885 32.6227 34.6436C32.8975 34.8015 33.0265 35.0025 33.0222 35.2225C33.0269 35.4525 32.8679 35.6538 32.5879 35.8147C32.3094 35.9747 31.9599 36.0604 31.5662 36.0642L31.5583 35.7633C31.8153 35.7609 32.0351 35.7071 32.2179 35.6021C32.4094 35.492 32.5029 35.3657 32.4985 35.2231C32.5027 35.0755 32.4206 34.9533 32.2522 34.8565C31.9237 34.6677 31.6987 34.4534 31.5772 34.2135C31.456 33.9638 31.4459 33.7179 31.547 33.4759C31.6484 33.2241 31.8645 33.0031 32.1953 32.813C32.5348 32.618 32.9022 32.494 33.2976 32.441C33.6845 32.3832 34.078 32.3943 34.4781 32.4741C34.8781 32.5539 35.2635 32.7003 35.634 32.9132C35.8699 33.0487 36.0443 33.234 36.1574 33.4691C36.2792 33.6991 36.3569 33.9739 36.3906 34.2933L36.8765 38.8342C36.8725 38.9719 36.9632 39.0941 37.1485 39.2005C37.3253 39.3022 37.5379 39.3543 37.7861 39.3568C38.043 39.3544 38.2672 39.2981 38.4587 39.1881L43.2899 36.412C43.4814 36.302 43.5793 36.1732 43.5835 36.0255C43.5878 35.8779 43.5015 35.7533 43.3246 35.6517C43.1562 35.5549 42.9435 35.5077 42.6866 35.5101C42.4213 35.5077 42.1928 35.5616 42.0013 35.6716L38.3453 37.7724L38.0508 34.1669C38.0315 33.9457 37.9825 33.7125 37.904 33.4673C37.8341 33.217 37.7168 32.9796 37.552 32.7548C37.396 32.5251 37.1832 32.3328 36.9137 32.178C36.2988 31.8247 35.6464 31.5898 34.9563 31.4734C34.2749 31.3519 33.5944 31.3461 32.9149 31.4559C32.2355 31.5656 31.5997 31.7906 31.0078 32.1307C30.4246 32.4658 30.0285 32.8434 29.8195 33.2636C29.6192 33.6787 29.6115 34.0944 29.7965 34.5108C29.973 34.9224 30.3476 35.2927 30.9203 35.6218C31.0888 35.7186 31.3014 35.7657 31.5583 35.7633L31.5662 36.0642C31.1798 36.0678 30.8267 35.9938 30.5498 35.8347C29.917 35.4712 29.4903 35.0539 29.2886 34.5845C29.0815 34.1176 29.0904 33.6488 29.3149 33.1836L29.316 33.1813C29.5515 32.7078 29.997 32.2863 30.6378 31.9181C31.2815 31.5482 31.9931 31.2923 32.774 31.1662C33.5507 31.0407 34.3329 31.0475 35.1083 31.1853C35.8969 31.3188 36.6215 31.5842 37.2842 31.965C37.6093 32.1518 37.8585 32.3793 38.0373 32.6413C38.2168 32.8869 38.3441 33.1453 38.42 33.4157C38.5016 33.6711 38.5533 33.9164 38.5738 34.1513L38.8129 37.0785L41.6313 35.459C41.919 35.2937 42.2803 35.2068 42.6872 35.2092C43.0703 35.2067 43.4203 35.2808 43.6952 35.4387C43.9751 35.5996 44.1136 35.8034 44.1071 36.03C44.1005 36.2603 43.942 36.4625 43.6599 36.6246L38.8287 39.4007C38.5466 39.5628 38.1946 39.6539 37.7939 39.6577H37.7758Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5151 16.5666C58.071 16.4351 58.712 16.5094 59.1392 16.7549L67.4026 21.5031C67.986 21.8383 67.9887 22.3802 67.4087 22.7134C66.8287 23.0467 65.8857 23.0451 65.3023 22.7099L59.5889 19.427L59.5931 20.2551C59.5955 20.7278 58.9306 21.1098 58.108 21.1085C57.2854 21.1071 56.6166 20.7228 56.6142 20.2501L56.5996 17.3558C56.5979 17.0097 56.9592 16.6982 57.5151 16.5666Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1681 32.7093C48.8048 33.0751 48.8048 33.6683 48.1681 34.0342C47.5314 34.4001 46.499 34.4001 45.8623 34.0342C45.2256 33.6683 45.2256 33.0751 45.8623 32.7093C46.499 32.3434 47.5314 32.3434 48.1681 32.7093Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2993 28.3276C56.8957 27.4103 56.9534 25.5873 54.6076 24.2394C52.2618 22.8914 49.0892 22.9246 47.4928 23.8419C45.8965 24.7592 45.8387 26.5822 48.1846 27.9301C50.5304 29.278 53.703 29.2448 55.2993 28.3276ZM56.6993 29.132C59.2462 27.6686 58.9365 25.1179 56.0076 23.4349C53.0787 21.7519 48.6397 21.574 46.0928 23.0374C43.546 24.5009 43.8557 27.0516 46.7846 28.7346C49.7135 30.4175 54.1524 30.5955 56.6993 29.132Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6875 22.9697L53.071 29.5942L51.1052 29.7298L49.7217 23.1052L51.6875 22.9697Z",
    fill: "#3399CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_696_100743",
    x: 0.100586,
    y: 28.1669,
    width: 96.7983,
    height: 34.2579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_696_100743"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42487
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_696_100743",
    result: "effect2_innerShadow_696_100743"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.04145
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_696_100743",
    result: "effect3_innerShadow_696_100743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_100743",
    x1: 0.100586,
    y1: 28.1669,
    x2: 24.9289,
    y2: 88.7833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AED6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_100743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv4);
export default __webpack_public_path__ + "static/media/adv-4.02f965df0ec3c0d96bbd3c028cfc8fae.svg";
export { ForwardRef as ReactComponent };